import { useEffect, useState } from "react";
import { X, Share, Plus } from "lucide-react";

const DISMISS_KEY = "km_a2hs_dismissed";

const isIOS = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

export default function InstallPrompt() {
  const [visible, setVisible] = useState(false);
  const [deferred, setDeferred] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) || isStandalone()) return;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);

    // iOS Safari never fires beforeinstallprompt — show manual instructions
    let timer;
    if (isIOS()) {
      timer = setTimeout(() => setVisible(true), 2500);
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      if (timer) clearTimeout(timer);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    dismiss();
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed bottom-4 left-4 right-4 z-40 mx-auto max-w-md chunky-card p-4 flex items-start gap-3 fade-in"
      style={{ backgroundColor: "#FFC400" }}
    >
      <div className="flex-1">
        <div className="font-display text-xl text-navy leading-tight">
          Put Kids Money on your home screen
        </div>
        {deferred ? (
          <button
            data-testid="install-app-btn"
            onClick={install}
            className="chunky-btn mt-3 px-4 py-2 text-lg text-navy"
            style={{ backgroundColor: "#7CE645" }}
          >
            INSTALL
          </button>
        ) : (
          <div className="font-display text-sm text-navy/80 mt-1 flex items-center gap-1 flex-wrap">
            Tap
            <Share className="w-4 h-4 inline" strokeWidth={3} />
            then
            <Plus className="w-4 h-4 inline" strokeWidth={3} />
            "Add to Home Screen"
          </div>
        )}
      </div>
      <button
        data-testid="dismiss-install-prompt-btn"
        onClick={dismiss}
        className="w-9 h-9 rounded-full border-3 border-navy bg-white flex items-center justify-center shrink-0"
        style={{ borderWidth: 3, boxShadow: "0 3px 0 0 #2A2D7C" }}
        aria-label="Dismiss"
      >
        <X className="w-4 h-4 text-navy" strokeWidth={3} />
      </button>
    </div>
  );
}
